import React from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { Text, TextProps } from "@jsq/ds/core";
import { Icon, IconSize } from "@jsq/ds/icons";
import { RiskRating } from "#graphql/supergraphTypes";
import { RISK_RATING_CONFIG } from "./constants";
import { labelColor, riskRatingBadge, riskRatingLabel } from "./styles_vanilla.css";

interface RiskRatingBadgeProps {
  rating: RiskRating;
  iconSize?: IconSize;
  textVariant?: TextProps["variant"];
}

export const RiskRatingBadge: React.FC<RiskRatingBadgeProps> = ({
  rating,
  textVariant = "regular-lg",
  iconSize = "medium",
}) => {
  const { iconType, color, label } = RISK_RATING_CONFIG[rating];

  return (
    <div className={riskRatingBadge}>
      {iconType && (
        <Icon
          size={iconSize}
          type={iconType}
          color={color}
          data-testid="risk-rating-badge-icon"
        />
      )}
      <Text
        variant={textVariant}
        className={riskRatingLabel}
        style={assignInlineVars({ [labelColor]: color })}
        data-testid="risk-rating-badge-label"
      >
        {label}
      </Text>
    </div>
  );
};
